import { fetchDetailedInternalRoute } from 'services/routes/actions'
import * as helpers from './helpers'

import {
  CREATE_WORKOUT,
  UPDATE_WORKOUT,
  FETCH_WORKOUT,
  FETCH_WORKOUT_COPY,
  FETCH_CALORIES,
  FETCH_USER_WORKOUTS,
  FETCH_USER_WORKOUTS_WITH_ROUTE,
} from './constants'

export function fetchWorkout (workoutId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_WORKOUT,
      payload: mapmy.getWorkoutById(workoutId),
    })
  }
}

export function fetchWorkoutCopy (workoutId) {
  return dispatch => {
    return dispatch({
      type: FETCH_WORKOUT_COPY,
      payload: dispatch(fetchWorkout(workoutId))
        .then(res => {
          const links = res.value.data._links
          const routeId = links.route ? links.route[0].id : undefined
          if (routeId) {
            return dispatch(fetchDetailedInternalRoute(routeId))
              .then(routeResponse => {
                const route = routeResponse.value.data
                const newResponse = { ...res }
                newResponse.value.data.route = route
                return newResponse
              })
          } else {
            return res
          }
        }),
    })
  }
}

export function createWorkout (values) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: CREATE_WORKOUT,
      payload: mapmy.postWorkout(values),
    })
  }
}

export function updateWorkout (values, id) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: UPDATE_WORKOUT,
      payload: mapmy.putWorkout(values, id),
    })
  }
}

export function fetchCalories (data) {
  return (dispatch, getState, { mapmy }) => {
    const {
      duration_hh: hh,
      duration_mm: mm,
      duration_ss: ss,
      distance,
    } = data

    const duration = helpers.calcDuration({ hh, mm, ss })

    return dispatch({
      type: FETCH_CALORIES,
      payload: mapmy.getCalories({ ...data, duration, distance }),
    })
  }
}

export function fetchUserWorkouts (userId, limit = 10, orderBy = '-start_datetime') {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_USER_WORKOUTS,
      payload: mapmy.getWorkouts(userId, limit, orderBy),
    })
  }
}

export function fetchUserWorkoutsWithRoute (userId, limit = 10, orderBy = '-start_datetime') {
  return (dispatch) => {
    const workoutPromises = Promise.resolve()
      .then(() => {
        return dispatch(fetchUserWorkouts(userId, limit, orderBy))
      })
      .then((res) => {
        const workouts = res.value.data._embedded.workouts

        const promises = workouts.map(workout => {
          const links = workout._links
          const routeId = links.route ? links.route[0].id : undefined

          if (routeId) {
            return dispatch(fetchDetailedInternalRoute(routeId))
              .then(routeResponse => {
                const route = routeResponse.value.data
                workout.route = route
                return workout
              })
          } else {
            return Promise.resolve().then(() => workout)
          }
        })

        return Promise.all(promises)
      })

    return dispatch({
      type: FETCH_USER_WORKOUTS_WITH_ROUTE,
      payload: workoutPromises,
    })
  }
}
